module.exports = __webpack_public_path__ + "img/steel-img-3.c1fd7a14.png";